module.exports = __webpack_public_path__ + "static/media/Ron Weasley 3.9b6fdabe.jpg";